import { render, staticRenderFns } from "./list-hibah-saksi.vue?vue&type=template&id=3cda6c8d&"
import script from "./list-hibah-saksi.vue?vue&type=script&lang=js&"
export * from "./list-hibah-saksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports